import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { ProductDetailPageComponent } from './pages/product-detail-page/product-detail-page.component';
// import { MobileUiComponent } from './pages/experiments/mobile-ui/mobile-ui.component';
import { ContactComponent } from './pages/contact/contact.component';
import { SizeChartComponent } from './components/size-chart/size-chart.component';
import { TermsOfServiceComponent } from './pages/terms-of-service/terms-of-service.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    data: { render: 'pre-render' },
  },
  // {
  //   path: '',
  //   component: ContactComponent,
  //   data: { render: 'pre-render' },
  // },
  {
    path: 'product/:handle',
    component: ProductDetailPageComponent,
    data: { render: 'pre-render' },
  },
  {
    path: 'contact',
    component: ContactComponent,
    data: { render: 'pre-render' },
  },
  {
    path: 'order',
    component: ContactComponent,
    data: { render: 'pre-render' },
  },
  {
    path: 'size-chart',
    component: SizeChartComponent,
    data: { render: 'pre-render' },
  },
  {
    path: 'terms-of-service',
    component: TermsOfServiceComponent,
    data: { render: 'pre-render' },
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
    data: { render: 'pre-render' },
  },
];
